import {
    ISymbolConfig,
    ISymbolData,
    ISymbolDim
} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/IReelSymbolData";
import {SymbolData} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import Point = PIXI.Point;

/**
 * Created by SH on 28/7/2019.
 */

export class WGSymbolData extends SymbolData {
    public static stackSymbols: string[] = ["M1", "M2", "M3", "M4", "M5", "W", "W1", "W2", "W3"];

    protected readonly _normalDim: ISymbolDim = {
        WIDTH: 120,
        HEIGHT: 199,
        PADDING_X: 0,
        PADDING_Y: 0,
        SCALE: new Point(1, 1)
    }
    protected SymbolsPreDefined: ISymbolConfig[] = [
        {
            NAME: "M1",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "M2",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "M3",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "M4",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "M5",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "W",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "W1",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "W2",
            DIM: this._normalDim,
            MULTISIZE: true
        },
        {
            NAME: "W3",
            DIM: this._normalDim,
            MULTISIZE: true
        }
    ]

    protected SpecialSymbols: string[] = WGSymbolData.stackSymbols;

    public static get DEFAULT_SYMBOL(): ISymbolData {
        return this._defaultConfiguration;
    }
}